/* ════════════════════════════════════════════════
   Flux Labs — STOCK SHAPE + EMERGENCY FALLBACK ONLY
   ▶ Supabase is now the SINGLE SOURCE OF TRUTH for live stock.
     Edit your stock in Supabase (the `stock` table) — the website pulls
     it automatically and updates INSTANTLY via realtime (plus a 16s poll
     as a safety net). You do NOT need to edit this file day to day.
   ▶ This file is only used:
       • to know the product/dose SHAPE (which items exist, single vs per-dose), and
       • as an offline fallback IF Supabase is ever unreachable.
   ▶ The numbers below are a snapshot synced to Supabase on 2026-06-25.
     They are auto-overridden by live Supabase values whenever the site loads.
   ▶ Rules: 0 = Sold Out (locked) · 1–4 = Low stock · 5+ = In stock.
   ▶ The website NEVER shows these exact numbers to customers.
   Use the product names exactly as below (BAC Water is treated the same as "Bac Water").
════════════════════════════════════════════════ */
/* A plain number = single-dose stock.
   An object = per-dose stock (use the exact dose labels). */
window.FLUX_STOCK = {
  'GLP-1':            { '10mg': 9 },
  'GLP-2':            { '10mg': 9, '30mg': 9 },
  'GLP-3':            { '10mg': 19, '30mg': 9 },
  'HCG':                    { '5,000 IU': 9 },
  'BPC-157 + TB-500':       { '10mg': 9 },
  'Glow':                   { '70mg': 9 },
  'GHK-Cu':                 { '50mg': 9, '100mg': 18 },
  'MT2':                    { '10mg': 9 },
  'CJC-1295 + Ipamorelin':  { '10mg': 9 },
  'IGF-1 LR3':              { '0.1mg': 9, '1mg': 9 },
  'MOTS-C':                 { '20mg': 9 },
  'Bac Water':              { '3ml': 30, '10ml': 38 },
  'Insulin Syringes': 60,
  'Pen Needles': 60
};
